export const createSchedulingList = (scheduling, multi) => {
  const { nestedSchedulings = [], ...schedulingWithoutNested } = scheduling
  return multi ? [schedulingWithoutNested, ...nestedSchedulings] : [schedulingWithoutNested]
}

export const shouldResetScheduling = () => {
  if (typeof window === 'undefined') return false
  try {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('resetScheduling') === 'true'
  } catch {
    return false
  }
}
